import { Button, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CommercialAirlineNavigationBar from "../../../../../components/element/CommercialAirlineNavigationBar";
import useAirlineAdminApi from "../../../../../services/api/useAirlineAdminApi";
import {
  ApprovalState,
  DisputeStatus,
  FLIGHT_PLAN_STATUS,
} from "../../../../../utils/constants";
import ROUTE_PATHS from "../../../../../utils/routePaths";
import {
  getAirlineName,
  getCommercialFlightPlanId,
  getFlightNumber,
} from "../../../../../utils/utils";
import "../ViewHistoricalData.css";
import PrintIcon from "../../../../../assets/images/print_icon.svg";


const ViewHistoricalDataHeader = ({
  airlineData,
  flightPlanDetail,
  isEditing,
  isAAUser,
  onClickEdit,
  onClickCancel,
  onClickSave,
  onClickConfirm,
  onClickCancelFlight,
  isLoadingSave,
  isLoadingConfirm,
  isLoadingFlightPlanApprovals,
  onClickPrint,
  flightPlanApprovals,
}) => {
  const isCanceled = flightPlanDetail?.status === FLIGHT_PLAN_STATUS.CANCELLED;
  const hasFlightPlanId = Boolean(getCommercialFlightPlanId(flightPlanDetail));
  const isApproved =
    flightPlanDetail?.status === FLIGHT_PLAN_STATUS.AA_APPROVAL || isAAUser
      ? flightPlanApprovals?.some(
        (item) => item.approvalState === ApprovalState.APPROVED_BY_AA
      )
      : flightPlanApprovals?.some(
        (item) => item.approvalState === ApprovalState.APPROVED_BY_AIRLINE
      );

  const { getAirlineById } = useAirlineAdminApi();

  const [airlineName, setAirlineName] = useState("");

  useEffect(() => {
    const fetchAirlineName = async () => {
      let name = getAirlineName(airlineData, flightPlanDetail?.airlineId);

      if (name === undefined && flightPlanDetail?.airlineId) {
        try {
          const airline = await getAirlineById(flightPlanDetail.airlineId);
          name = airline?.data?.airlineName || "";
        } catch (error) {
          console.error("Error fetching airline name:", error);
          name = "";
        }
      }
      setAirlineName(name ? `- ${name}` : "");
    };

    fetchAirlineName();
  }, [airlineData, flightPlanDetail, getAirlineById]);
  return (
    <div>
      <CommercialAirlineNavigationBar showHeaderBar={false} />
      <header className="edit-flight-roster-header">
        <div className="edit-flight-roster-header-bar-container">
          <div className="edit-flight-roster-header-bar">
            <div className="edit-flight-roster-left">
              <div className="navigation-header">
                <Link
                  to={ROUTE_PATHS.COMMERCIAL_AIRLINE_HOME}
                  className="navigation-header-link"
                >
                  Home/
                </Link>
                <Link
                  to={ROUTE_PATHS.COMMERCIAL_AIRLINE_FLIGHT_ROSTER}
                  className="navigation-header-link"
                >
                  Flight Roster/Historical Data/
                </Link>
                View
              </div>
            </div>
            <p className="edit-flight-roster-center">{`${getFlightNumber(
              flightPlanDetail
            )} ${airlineName ? `${airlineName}` : ""}`}</p>
            <div className="edit-flight-roster-right">
              {!isCanceled ? (
                isEditing ? (
                  <>
                    <Button
                      variant="contained"
                      className="cancel"
                      onClick={onClickCancel}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      onClick={onClickSave}
                      disabled={!hasFlightPlanId}
                    >
                      {isLoadingSave ? (
                        <CircularProgress size={20} color="inherit" />
                      ) : (
                        "Save"
                      )}
                    </Button>
                  </>
                ) : (
                  <>
                    {isApproved && isAAUser && (
                      <Button
                        variant="contained"
                        className="print-button"
                        onClick={onClickPrint}
                      >
                        <img src={PrintIcon} alt="print" />
                        Print
                      </Button>
                    )}

                    {flightPlanDetail?.status ===
                      FLIGHT_PLAN_STATUS.AA_APPROVAL ? (
                      <></>
                    ) : (
                      <>
                        <Button
                          variant="contained"
                          className="cancel-flight"
                          onClick={onClickCancelFlight}
                          disabled={!hasFlightPlanId}
                        >
                          Cancel Flight
                        </Button>
                        {!isApproved &&
                          !isLoadingConfirm &&
                          !isLoadingFlightPlanApprovals && (
                            <Button
                              variant="contained"
                              className="cancel"
                              onClick={onClickEdit}
                              disabled={
                                !hasFlightPlanId ||
                                flightPlanDetail?.status ===
                                  FLIGHT_PLAN_STATUS.AA_APPROVAL
                              }
                            >
                              Edit
                            </Button>
                          )}
                        {!isApproved &&
                          !isLoadingConfirm &&
                          !isLoadingFlightPlanApprovals && (
                            <Button
                              variant="contained"
                              className="confirm"
                              disabled={
                                !hasFlightPlanId ||
                                (isAAUser &&
                                  flightPlanDetail?.disputeStatus ===
                                    DisputeStatus.RAISED)
                              }
                              onClick={onClickConfirm}
                            >
                              {isLoadingConfirm ? (
                                <CircularProgress size={20} color="inherit" />
                              ) : (
                                "Confirm"
                              )}
                            </Button>
                          )}
                      </>
                    )}
                  </>
                )
              ) : null}
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

export default ViewHistoricalDataHeader;
